// @ts-nocheck
import { ErrorBoundary } from '@rollbar/react'
import { ComponentType, ReactNode } from 'react'

export const withErrorBoundary =
  <T,>(Component: ComponentType<T>, fallback?: ReactNode) =>
  // eslint-disable-next-line react/display-name
  <T,>(props: T) =>
    (
      <ErrorBoundary fallbackUI={fallback ?? null}>
        <Component {...props} />
      </ErrorBoundary>
    )
